import { Component, ReactNode } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router';
import { AdminApi } from '../admin-api';
import PageLoading from './PageLoading';

export default function FinishGoogleCalendarActivation(props: any): ReactNode {
  const [searchParams] = useSearchParams();

  return (
    <FinishGoogleCalendarActivationComp
      navigate={useNavigate()}
      params={useParams()}
      query={searchParams}
      {...props}
    />
  );
}

class FinishGoogleCalendarActivationComp extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser?: any;
      params?: any;
      query?: any;
    }>,
  ) {
    super(props);

    this.state = {
      isLoading: true,
    };
  }

  state: Readonly<{
    isLoading: boolean;
  }>;

  async componentDidMount(): Promise<void> {
    await AdminApi.post(`/events/googleapi/auth/token`, {
      code: this.props.query.get('code'),
    });

    this.setState({ isLoading: false });
  }

  render(): ReactNode {
    return this.state.isLoading ? (
      <PageLoading />
    ) : (
      <div className="alert alert-success">
        Conectado! Pode voltar a usar o Plurie Admin
      </div>
    );
  }
}
